import React from 'react';
import './Copies.scss';
import globeIG1 from '../../assets/gobeIG1.png';
import globeIG2 from '../../assets/globeIG2.svg';

function Copy4() {
  return (
    <>
      <section className="copies">
        <h4 className="copies__title title">The Science of Eczema</h4>{' '}
        <div className="infoGraphic ">
          <img src={globeIG1} alt="globe" />
          <img src={globeIG2} alt="text" />
        </div>
        <p className="copies__copy">
          Eczema affects millions of people worldwide, with up to 10% of adults and up to 20% of
          children estimated to have this common, chronic inflammatory skin condition.
        </p>
        <p className="copies__copy">
          “Eczema is diagnosed by the presence of a chronic, itchy relapsing eczematous rash—dry,
          scaling, or crusted lesions on the skin,” Dr. Colombo says. “It’s associated with dry skin
          and typically seen in atopic patients, [or those] with a personal or family history of
          eczema, seasonal allergies (hay fever), or asthma.”
        </p>
        <p className="copies__copy">
          According to Dr. Colombo, severe itch associated with the rashes is the main symptom that
          makes eczema such a difficult condition for patients to deal with. “It can literally keep
          patients up at night leading to daytime drowsiness, fatigue, and irritability,” she says.
          This can be true for eczema patients with very demanding lives. The lack of sleep caused
          by eczema has really affected Boey and his job in the fashion industry. “Working in
          production, sometimes you get early calls and if you can't sleep the night before it's
          going to be hell the next day,” he says.
        </p>
        <p className="copies__copy">
          And as Dr. John Koo, a psychodermatologist and professor at the University of California,
          San Francisco, points out, scratching that persistent itch can oftentimes make eczema
          flares worse—setting off an “itch-scratch cycle.”
        </p>
        <p className="copies__copy">
          “[That] scratching damages the skin and also introduces more bacteria from your
          fingernail,” he says. “And then the trauma itself can also worsen inflammation. And the
          more the rash worsens, the more itchy it gets; it’s a vicious cycle.” He adds that it's
          not uncommon that over the course of a year, a patient may spend more than 150 days
          experiencing flare-ups.
        </p>
      </section>
    </>
  );
}

export default Copy4;
